



















import Vue from 'vue';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';
import util from '@/components/util';
import SelectBox from '@/components/util/NewSelectBox.vue';
import { ISelectOption } from '@/class/models/typed/wild';

interface Data {
  inputedSearchDepartment: number;
}
interface Methods {
  onClickClose: () => void;
  moveUserToOtherDep: () => void;
}
interface Computed {
  DEPARTMENTS: ISelectOption[];
}
interface Props {
  optionsDepartment: ISelectOption[];
}

export default Vue.extend({
  name: 'ModalExclusionDepartment',
  components: { ...util, SelectBox},
  props: {
    optionsDepartment: Array,
  },
  computed: {
    DEPARTMENTS() {
      return this.optionsDepartment.filter((v: any) => v.value !== 0);
    },
  },
  data() {
    return {
      inputedSearchDepartment: 0,
      // 検証用
      // optionsDepartment: [ NOC.SELECT.ALL_DEPARTMENTS ] as ISelectOption[],
    };
  },
  methods: {
    onClickClose() {
      this.$emit('close');
    },
    moveUserToOtherDep() {
      this.$emit('moveUserToOtherDep', this.inputedSearchDepartment);
      this.$emit('close');
    },
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>);
